
/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestOneSalerSettlement {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 委托书主键
     */
    PoolId?: string;
    /**
     * 
     */
    Month?: string;
    /**
     * 
     */
    SalerId?: string;
    /**
     * 核销主键
     */
    SettlementId?: string;
}

/**
 * -表单校验
 */
export const DtoRequestOneSalerSettlementRules = {
}
